<template>
  <div>
    <h2 class="title white">Por favor selecione um atendimento</h2>
    <div class="ui two column centered grid">
      <div class="column main-column">
        <div v-show="!is_checkin" class="row">
          <button id="consulta" class="massive ui button" @click.prevent="(buttonClicked('consulta'), doTransition($event))">
              <img :src="'static/img/icon-kiosk-consulta.png'" alt="">
              <span>agendar consulta</span>
          </button>
        </div>
        <div v-show="!is_checkin" class="row">
          <button id="exame" class="massive ui button" @click.prevent="(buttonClicked('exame'), doTransition($event))">
            <img :src="'static/img/icon-kiosk-exame.png'" alt="">
            <span>agendar exame</span>
          </button>
        </div>
        <div class="ui two column centered grid">
          <div class="three column centered row">
            <!-- <div class="column btn-checkin" style="width: 49% !important;"> -->
            <div class="column btn-checkin">
              <button id="checkin" class="massive ui button" style="width: -webkit-fill-available;"
                @click.prevent="(buttonClicked('CheckinCpf'), doTransition($event))">
                <div style="display: inline-table; margin: 0 auto;">
                  <img :src="'static/img/icon-kiosk-checkin.png'" alt="">
                  <i class="credit card outline icon" style="font-size: 1.5em; padding-top: 44px;"></i>
                </div>
                <span>check-in CPF</span>
              </button>
            </div>
            <!-- <div class="column btn-checkin" style="width: 50% !important;"> -->
            <div class="column btn-checkin">
              <button id="checkin" class="massive ui button" style="width: -webkit-fill-available;"
                @click.prevent="(buttonClicked('CheckinTel'), doTransition($event))">
                <div style="display: inline-table; margin: 0 auto;">
                  <img :src="'static/img/icon-kiosk-checkin.png'" alt="">
                  <i class="phone icon" style="font-size: 1.5em; padding-top: 44px;"></i>
                </div>
                <span>check-in Telefone</span>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    ticket: Object
  },
  data() {
    return {
      is_checkin: false
    }
  },
  mounted() {

    let url = window.location.href.split('/');
    let checkin = url.find((elem, index, array) => {
      return (elem == '?checkin');
    })
    if (checkin) {
      console.log(checkin)
      this.is_checkin = true;
      //this.$emit('buttonClicked', 'CheckinCpf');
    }
  },
  methods: {
    doTransition(event) {
      let elem;
      let parent = event.target.parentNode;
      if (parent.tagName != 'BUTTON') {
        elem = event.target.id;
      } else {
        elem = parent.id;
      };
      $('#' + elem).transition('pulse');
    },
    buttonClicked(filter) {
      this.$emit('buttonClicked', filter);
    },
  }
}
</script>
<style scoped>
@media only screen and (min-width: 320px) {
  .ui.button {
    width: -webkit-fill-available;
    height: 130px;
    font-size: 36px;
  }
  .ui.button img {
    width: 80px;
  }
  button span {
    font-size: 24px;
  }
}

@media only screen and (min-width: 500px) {
  #app h2 {
    font-size: 42px;
  }
  .ui.button {
    /* width: 800px; */
    height: 180px;
    font-size: 36px;
  }
  .ui.button img {
    width: 120px;
  }
  button span {
    font-size: 36px;
  }
}

@media only screen and (max-width: 1024px) {
  .ui.two.column.centered.grid .main-column {
    width: 100%!important;
  }
  .three.column.centered.row .column.btn-checkin {
    width: 100%!important;
  }
}

@media only screen and (min-width: 1024px) {
  .three.column.centered.row .column.btn-checkin {
    width: 49%!important;
  }
}


h2 {
  font-weight: bold;
  font-family: 'Source Sans Light';
}
.ui.button {
  display: grid;
  margin: 10px auto;
  padding: 0px;
  /* margin: 10px 0px; */
  text-transform: capitalize;
  font-family: 'Source Sans ExtraLight';
  font-weight: bold;
  border: 1px solid #ececec;
  border-radius: 20px;
  background: rgb(255,255,255);
  background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(236,236,236,1) 80%);
  /* box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 1px 2px rgba(0, 0, 0, 0.23); */
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
}
.ui.button:hover {
  background: rgb(255,255,255);
  background: linear-gradient(180deg, rgba(255,255,255,1) 52%, rgba(224,224,224,1) 100%);
}
.ui.button:not(.icon) > .icon:not(.button):not(.dropdown) {
  width: 100%;
  margin: 0px;
  font-size: 64px;
  padding-top: 20px;
  margin-bottom: 20px;
}
.ui.button img {
  position: relative;
  float: left;
  margin: 0 auto;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/components/StartPage.vue